<template>
  <div
    :class="['jpslide', textPosition && `text-${textPosition}`]"
    :style="{ backgroundImage: `url('${img}')` }"
  >
    <div class="overlay"></div>
    <div class="content">
      <TextHeading :iconName="icon">
        <template slot="title" v-if="title">
          {{ title }}
        </template>
        <template slot="subtitle" v-if="subtitle">
          {{ subtitle }}
        </template>
        <template slot="after" v-if="text">
          <span v-html="text"></span>
        </template>
      </TextHeading>
    </div>
  </div>
</template>

<style lang="scss">
.jpslide {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  position: relative;

  .content {
    position: relative;

    .text-heading {
      z-index: 2;
      @include setColor(--color-text-negative);

      &__title,
      &__subtitle {
        @include setColor(--color-text-negative);
      }
    }
  }

  &.text-top {
    align-items: start;
  }

  .overlay {
    position: absolute;
    @include setColor(--color-overlay, background-color);
    opacity: 0.376;
    width: rem(100%);
    height: rem(100%);
    z-index: 1;
  }
}
</style>

<script>
import TextHeading from "../TextHeading/TextHeading";
export default {
  name: "Slide",

  components: {
    TextHeading,
  },

  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    img: {
      type: String,
      required: true,
    },
    text: {
      type: String,
    },
    icon: {
      type: String,
    },
    textPosition: {
      validator: prop => typeof prop === "string" || prop === null,
    },
  },
};
</script>
